import { cn } from '#/lib/utils';

/**
 * 工單雙欄「已加入明細」物料 group 標題列底色。
 * @param {{ open?: boolean, highlighted?: boolean }} opts
 */
export function draftGroupHeaderBarClassName({ open = false, highlighted = false } = {}) {
  return cn(
    'draft-group-header px-3 py-2 flex justify-between items-center gap-3 shortcut_transition',
    open && !highlighted && 'bg-slate-50',
    highlighted && 'bg-primary-200/65',
  );
}
